module.exports = __webpack_public_path__ + "static/media/27-8.fcee9755.mp3";